// extracted by mini-css-extract-plugin
export default {"portfolioErrorContainer":"styles_portfolioErrorContainer__sTHfR","spinnerWrapper":"styles_spinnerWrapper__VnIpk","errorIcon":"styles_errorIcon__ZYwI7"};